export default __webpack_public_path__ + "static/media/Proffiecient.fc84ed8d.svg";